export default "__VITE_ASSET__EsqiS3ld__"